import "./MoveSetting.css"
import arrowPic from "../../../assets/arrow.png"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { moveUp,moveDown,moveRight,moveLeft } from "../../../actions"

const MoveSetting = () => {

    const dispatch = useDispatch()

    const [timer, setTimer] = useState(null)

    const handleMoveUp = () => {
        dispatch(moveUp())
        const newTimer = setTimeout(handleMoveUp, 100)
        setTimer(newTimer)
    }

    const handleMoveDown = () => {
        dispatch(moveDown())
        const newTimer = setTimeout(handleMoveDown, 100)
        setTimer(newTimer)
    }

    const handleMoveLeft = () => {
        dispatch(moveLeft())
        const newTimer = setTimeout(handleMoveLeft, 100)
        setTimer(newTimer)
    }

    const handleMoveRight = () => {
        dispatch(moveRight())
        const newTimer = setTimeout(handleMoveRight, 100)
        setTimer(newTimer)
    }

    const handleStopMove = () => {
        clearTimeout(timer)
        setTimer(null)
    }

    return(
        <div className="MoveSetting">
            <div className="moveBtns">
                <button className="up" onMouseDown={handleMoveUp} onMouseUp={handleStopMove} onMouseLeave={handleStopMove}><img src={arrowPic} alt=""/></button>
                <button className="left" onMouseDown={handleMoveLeft} onMouseUp={handleStopMove} onMouseLeave={handleStopMove}><img src={arrowPic} alt="" /></button>
                <button className="down" onMouseDown={handleMoveDown} onMouseUp={handleStopMove} onMouseLeave={handleStopMove}><img src={arrowPic} alt="" /></button>
                <button className="right" onMouseDown={handleMoveRight} onMouseUp={handleStopMove} onMouseLeave={handleStopMove}><img src={arrowPic} alt="" /></button>
            </div>
        </div>
    )
}


export default MoveSetting
